import { render, staticRenderFns } from "./CommonTripleChooseModal.vue?vue&type=template&id=2cc6df02&scoped=true&"
import script from "./CommonTripleChooseModal.vue?vue&type=script&lang=js&"
export * from "./CommonTripleChooseModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonTripleChooseModal.vue?vue&type=style&index=0&id=2cc6df02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6df02",
  null
  
)

export default component.exports